import { render, staticRenderFns } from "./GadgetBuild.vue?vue&type=template&id=7f04d8c2&"
import script from "./GadgetBuild.vue?vue&type=script&lang=js&"
export * from "./GadgetBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports